import { Box, Spinner, Tab, TabIndicator, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import ProjectDetails from './ProjectDetails';
import PotentialInvestorsTab from './PotentialInvestorsTab';
import { useAppStore, AppStoreState } from '../../store';
import SimilarProjectTab from './SimilarProjectTab';
import ProjectInvestorsTab from './ProjectInvestors';
import { getProjectById } from '../../api/InvestorSearch/search';
import { useLocation } from 'react-router-dom';
import MobileMenu from '../mobileComponents/MobileMenu';

export default function ProjectInfoMain() {
  const location = useLocation();
  const setProjectById = useAppStore((state: AppStoreState) => state.setProjectById);
  const projectById = useAppStore((state: AppStoreState) => state.projectById);
  const loading = useAppStore((state: AppStoreState) => state.loading);
  const projectId = useAppStore((state: AppStoreState) => state.projectId);
  const setLoading = useAppStore((state: AppStoreState) => state.setLoading);

  const getProjectByID = async (id: number) => {
    try {
      setLoading(true);
      const res = await getProjectById(id);
      if (res) {
        setProjectById(res as any);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log('Error While Fetch All Users ', err);
    }
  };

  useEffect(() => {
    if (!projectId) {
      const projId = Number(location.pathname.split('/').pop());
      getProjectByID(projId);
    } else {
      getProjectByID(projectId);
    }
  }, [projectId, location.pathname]);

  return (
    <>
      {loading ? (
        <Box height="100vh" display="flex" justifyContent="center" alignItems="center">
          <Spinner />
        </Box>
      ) : (
        <>
          <Box
            background="#F5F5F5"
            w="100%"
            padding="24px"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
            overflowY="auto"
          >
            <ProjectDetails />
            <Tabs
              position="relative"
              width="100%"
              borderRadius="16px"
              border="1px solid rgba(0, 0, 0, 0.10)"
              background="#FFF"
              variant="unstyled"
              marginTop="14px"
              padding="24px 20px"
            >
              <TabList>
                <Tab>
                  <Text fontSize="14px" fontWeight={500}>
                    Potential Investors
                  </Text>
                </Tab>
                <Tab>
                  <Text fontSize="14px" fontWeight={500}>
                    Project Investors
                  </Text>
                </Tab>
                <Tab>
                  <Text fontSize="14px" fontWeight={500}>
                    Similar Projects
                  </Text>
                </Tab>
              </TabList>
              <TabIndicator mt="-1.5px" height="2px" bg="blue.500" borderRadius="1px" />
              <TabPanels>
                <TabPanel>
                  {projectById?.potential_investors && (
                    <PotentialInvestorsTab potentialInvestorsData={projectById?.potential_investors} />
                  )}
                </TabPanel>
                <TabPanel>
                  <ProjectInvestorsTab projectInvestorsData={projectById?.Project?.investors} />
                </TabPanel>
                <TabPanel>
                  {projectById?.Project?.similar_project && (
                    <SimilarProjectTab similarProject={projectById?.Project?.similar_project} />
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
          <Box display={['block', 'block', 'none']} width="94%" margin="0 auto">
            <MobileMenu />
          </Box>
        </>
      )}
    </>
  );
}
